import {
  UserCircleIcon,
  ChatBubbleBottomCenterTextIcon,
  HeartIcon,
  HomeIcon,
  ArrowRightOnRectangleIcon,
  LifebuoyIcon,
  DocumentTextIcon,
  BookOpenIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "redux/store";
import { logout } from "../../redux/reducers/AuthSlice/AuthSlice";
import API from "utils/helpers/APIHelper";
import { ENDPOINTS } from "API/apiConstants";

export const solutions = [
  {
    name: "Home",
    href: "/",
    icon: HomeIcon,
    role: "common",
  },
  {
    name: "Account",
    href: "/account",
    icon: UserCircleIcon,
    role: "common",
  },
  {
    name: "Messages",
    href: "/messages",
    icon: ChatBubbleBottomCenterTextIcon,
    role: "common",
  },
  {
    name: "Pending Bookings",
    href: "/manage_bookings",
    icon: BookOpenIcon,
    role: "host",
  },
  {
    name: "My Bookings",
    href: "/my_bookings",
    icon: BookOpenIcon,
    role: "common",
  },
  {
    name: "Previous Bookings",
    href: "/legacy_bookings",
    icon: BookOpenIcon,
    role: "legacy",
  },
  {
    name: "Favorite",
    href: "/favorite-listings",
    icon: HeartIcon,
    role: "student",
  },
  {
    name: "Booking-Queries",
    href: "/booking_queries",
    icon: UserCircleIcon,
    role: "common",
  },
  {
    name: "My Reservation",
    href: "/manage_bookings",
    icon: BookOpenIcon,
    role: "student",
  },
  {
    name: "Invoices",
    href: "/invoice",
    icon: DocumentTextIcon,
    role: "common",
  },
  {
    name: "List New Property",
    href: "add-listing-1",
    icon: PlusIcon,
    role: "host",
  },
  {
    name: "My Properties",
    href: "/my_propeties",
    icon: HomeIcon,
    role: "host",
  },
];

export default function FooterDropDown() {
  const [hasLegacyBookings, setHasLegacyBookings] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { currentUser, unreadChatCount } = useSelector(
    (state: RootState) => state.user
  );
  const { authenticated } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (!authenticated) return; // Don't call API when logged out
    API.get(ENDPOINTS.LEGACY_BOOKINGS)
      .then((data: any) => {
        const list = Array.isArray(data)
          ? data
          : data?.bookings ?? data?.data ?? [];
        setHasLegacyBookings(list.length > 0);
      })
      .catch(() => {});
  }, [authenticated]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const solutionsFoot = [
    {
      name: "Help",
      href: "##",
      icon: LifebuoyIcon,
      onClick: () => {},
    },
    !authenticated
      ? {
          name: "Login",
          href: "##", // <- just link to the login page
          icon: UserCircleIcon,
          onClick: handleLogin,
        }
      : {
          name: "Logout",
          href: "##",
          icon: ArrowRightOnRectangleIcon,
          onClick: handleLogout,
        },
  ];

  return (
    <div className="">
      <div className="">
        <div className=" w-full">
          <div className="">
            <div className="relative grid gap-6 p-7">
              {solutions.map((item, index) => {
                const isStudent =
                  currentUser?.is_student && item.role === "student";
                const isHost = currentUser?.is_host && item.role === "host";
                const isCommon = item.role === "common";
                const isLegacy = item.role === "legacy" && hasLegacyBookings;

                if (isStudent || isHost || isCommon || isLegacy) {
                  return (
                    <Link
                      key={index}
                      to={item.href}
                      className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                    >
                      <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                        <item.icon aria-hidden="true" className="w-6 h-6" />
                      </div>
                      <div className="ml-4">
                        <p className="text-sm font-medium">{item.name}</p>
                      </div>
                      {item.name === "Messages" && unreadChatCount > 0 && (
                        <span className="ml-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
                          {unreadChatCount}
                        </span>
                      )}
                    </Link>
                  );
                }

                return null;
              })}
            </div>
            <hr className="h-[1px] border-t border-neutral-300 dark:border-neutral-700" />
            <div className="relative grid gap-6 p-7">
              {solutionsFoot.map((item, index) => (
                <button
                  key={index}
                  onClick={item.onClick}
                  className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                >
                  <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                    <item.icon aria-hidden="true" className="w-6 h-6" />
                  </div>
                  <div className="ml-4">
                    <p className="text-sm font-medium">{item.name}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
